import {
  MarketingCarouselTile,
  TileStatus,
  TileType,
} from '@varo/graphql-schema-types';
import { HomeCardDependencies } from 'features/home/HomeScreen/dependencies/types';
import { BrazeContentCard } from 'services/engagement/braze/types';
import { VXLMarketingCardProps } from 'shared/components/vxl/cards/VXLMarketingCard/VXLMarketingCard';
import { VXLComponent, VXLComponentId } from 'shared/renderer/types';

export interface MarketingCarouselCard {
  id: string;
  labelText: string;
  headlineText: string;
  illustration: VXLMarketingCardProps['illustration'];
  colorTheme?: VXLMarketingCardProps['colorTheme'];
  url?: string;
  sourceCard: BrazeContentCard;
}

export const mapBrazeCardsToCarouselCards = (
  contentCards: BrazeContentCard[],
): MarketingCarouselCard[] =>
  contentCards.map((card, index) => ({
    id: card.id ?? `marketing-card-${index}`,
    labelText: card.ctaTitle ?? card.description ?? '',
    headlineText: card.title ?? '',
    illustration: card.imageUrl ? { uri: card.imageUrl } : 'PLACEHOLDER_A',
    colorTheme:
      (card.cardBackground as VXLMarketingCardProps['colorTheme']) ?? undefined,
    url: card.url ?? undefined,
    sourceCard: card,
  }));

interface MarketingCarouselTileNode extends VXLComponent {
  id: string;
  name: VXLComponentId.MARKETING_CARD_CAROUSEL;
  props: Record<string, unknown>;
}

const marketingCarouselTile = (
  tile: MarketingCarouselTile,
  { marketingCarouselCards, logContentCardClicked }: HomeCardDependencies,
): MarketingCarouselTileNode | null => {
  if (
    tile.status !== TileStatus.Loaded ||
    tile.tileType !== TileType.MarketingCarousel ||
    !marketingCarouselCards.length
  ) {
    return null;
  }

  return {
    id: tile.id,
    name: VXLComponentId.MARKETING_CARD_CAROUSEL,
    props: {
      contentCards: marketingCarouselCards,
      onCardClick: logContentCardClicked,
    },
  };
};

export default marketingCarouselTile;
